import React from 'react'
import tw, { css, styled } from 'twin.macro'

import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from 'gatsby'

const BannerSection = styled.section`
	height: 500px;
	max-height: 500px;
	background: url('${({ bg }) => (bg ? bg : '')}');
	${tw`bg-cover bg-no-repeat w-full bg-center`}

	@media(min-width:325px) {
		height: 250px;
		max-height: 250px;
	}

	@media(min-width:525px) {
		height: 300px;
		max-height: 300px;
	}

	@media(min-width:768px) {
		height: 300px;
		max-height: 300px;
	}

	@media(min-width:1024px) {
		height: 400px;
		max-height: 400px;
	}
	@media(min-width:1280px) {
		height: 500px;
		max-height: 500px;
	}

`
const BannerContainer = styled.div`
	${tw`flex flex-col justify-center h-full w-11/12 lg:w-9/12 m-auto`}
`
const BannerHook = styled.h3`
	@media (min-width: 525px) {
		${tw`text-3xl`}
	}
	${tw`font-display text-white text-2xl lg:text-4xl xl:text-5xl font-bold`}
	text-shadow: 10px 6px 8px rgba(0,0,0,.75);
`
const BannerSubText = styled.p`
	@media (min-width: 525px) {
		${tw`text-2xl w-8/12`}
	}
	${tw`font-display text-white text-xl lg:text-3xl xl:text-4xl w-10/12 md:w-7/12 xl:w-6/12`}
	text-shadow: 10px 6px 8px rgba(0,0,0,.75);
`
const ButtonBannerContainer = tw.div`mt-8`
const BannerUrlButton = styled.button`
	${tw`font-display text-white uppercase text-white text-sm md:text-base py-2 lg:py-4 px-6 leading-none border border-yellow-500 bg-yellow-500 hover:border-yellow-400 hover:bg-yellow-400 rounded`}
`

const WhichModel = ({ data, checkedLocale }) => {
	const lastBannerOption = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<BannerSubText>{children}</BannerSubText>
			),
		},
	}

	return (
		<BannerSection bg={data.backgroundImage.file.url}>
			<BannerContainer>
				<BannerHook>{data.hook}</BannerHook>
				{documentToReactComponents(data.description.json, lastBannerOption)}
				<ButtonBannerContainer>
					<Link to={`${checkedLocale}/${data.mainActionUrl}/`}>
						<BannerUrlButton>{data.mainActionText}</BannerUrlButton>
					</Link>
				</ButtonBannerContainer>
			</BannerContainer>
		</BannerSection>
	)
}

export default WhichModel
